import { ApolloClient, InMemoryCache, HttpLink } from "apollo-boost";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import { ApolloLink } from "apollo-link";
import cookie from "js-cookie";
import fetch from "isomorphic-unfetch";

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPH_API_URL,
  fetch: fetch
});

const catchGraphQlErrors = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      switch (err.extensions.code) {
        case "UNAUTHENTICATED":
          console.error(err.message);
          // If token has expired log agent out
          break;
        case "ANOTHER_ERROR_CODE": 
          break;
        case "NOT_FOUND":
          //TO DO
          break; 
        default:
             
      }
    }
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const authLink = setContext((_, { headers }) => {
  const token = cookie.get("ap.token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

const cache = new InMemoryCache();

const client = new ApolloClient({
  connectToDevTools: (process.env.NODE_ENV === 'production') ? false : true,
  link: ApolloLink.from([authLink, catchGraphQlErrors, httpLink]),
  cache
});


export default client;
